import api from './api';

export const getSpeciesSummary = (tenantId) =>
  api.get(`/api/stewardship/${tenantId}/species-summary`);

export const createLakeGuidanceBatch = (tenantId, data) =>
  api.post(`/api/stewardship/${tenantId}/lakes/batch-guidance`, data);

export const getPolygonsForSpecies = (speciesId, tenantId) =>
  api.get('/api/stewardship/citizen/polygons', { params: { speciesId, tenantId } });

export const getCitizenSpeciesList = (tenantId) =>
  api.get('/api/stewardship/citizen/species', { params: { tenantId } });

export const getPolygons = (tenantId, params) =>
  api.get(`/api/stewardship/${tenantId}/polygons`, { params });

export const getTraditionalLandPolygons = (tenantId) =>
  api.get(`/api/stewardship/${tenantId}/traditional-lands`);

export const getPolygon = (tenantId, id) =>
  api.get(`/api/stewardship/${tenantId}/polygons/${id}`);

export const createPolygon = (tenantId, data) =>
  api.post(`/api/stewardship/${tenantId}/polygons`, data);

export const updatePolygon = (tenantId, id, data) =>
  api.patch(`/api/stewardship/${tenantId}/polygons/${id}`, data);

export const approvePolygon = (tenantId, id) =>
  api.post(`/api/stewardship/${tenantId}/polygons/${id}/approve`);

export const archivePolygon = (tenantId, id) =>
  api.post(`/api/stewardship/${tenantId}/polygons/${id}/archive`);

export const deletePolygon = (tenantId, id) =>
  api.delete(`/api/stewardship/${tenantId}/polygons/${id}`);

export const getLayerPolygons = (tenantId, sourceDataset) =>
  api.get(`/api/stewardship/${tenantId}/layer-polygons`, { params: { sourceDataset } });

export const getAssignments = (tenantId, params) =>
  api.get(`/api/stewardship/${tenantId}/assignments`, { params });

export const createAssignment = (tenantId, data) =>
  api.post(`/api/stewardship/${tenantId}/assignments`, data);

export const updateAssignment = (tenantId, id, data) =>
  api.patch(`/api/stewardship/${tenantId}/assignments/${id}`, data);

export const approveAssignment = (tenantId, id) =>
  api.post(`/api/stewardship/${tenantId}/assignments/${id}/approve`);

export const archiveAssignment = (tenantId, id) =>
  api.post(`/api/stewardship/${tenantId}/assignments/${id}/archive`);

export const getEvidenceSummary = (tenantId, assignmentId) =>
  api.get(`/api/stewardship/${tenantId}/assignments/${assignmentId}/evidence`);
